module.exports = __webpack_public_path__ + "img/lion_top.78dbf9ac.png";